import { getCategoryById } from "../get-program-id";
import { PAGE_PATH } from "../../config";

/**
 * @param {*} currentPage
 * @param {*} data
 * @returns event name and parameter for segment
 */
export function parseOnboardingDataToSegment(currentPage, data) {
  let eventName = null;
  let parameters = null;

  switch (currentPage) {
    case "anxiety_profile_comfortability_page":
      eventName = "New user - Choose Comforts";
      parameters = {
        chooseComforts: data.choose_comforts.toString(),
      };
      break;
    case "anxiety_profile_feeling_page":
      eventName = "New user - Choose Feeling";
      parameters = {
        chooseFeelings: data.choose_feeling,
      };
      break;
    case "anxiety_profile_fears_page":
      eventName = "New user - Choose Fears";
      parameters = {
        chooseFears: data.choose_fears.toString(),
      };
      break;
    case "parent_choose_child_phobia_page":
      eventName = "New user - Phobia selected";
      parameters = {
        programmeCategory: data.choose_phobias,
        programmeCategoryName: data.choose_phobias.map(
          (pid) => getCategoryById(pid).phobia
        ),
      };
      break;
    case "choose_problem_page":
      if (data.choose_phobias === 4) {
        eventName = "New user - Phobia selected";
        parameters = {
          programmeCategory: getCategoryById(data.choose_phobias).id,
          programmeCategoryName: getCategoryById(data.choose_phobias).phobia,
        };
      }
      break;
    case "choose_phobia_page":
      eventName = "New user - Phobia selected";
      parameters = {
        programmeCategory: getCategoryById(data.choose_phobias).id,
        programmeCategoryName: getCategoryById(data.choose_phobias).phobia,
      };
      break;
    case "choose_path_page":
      eventName = "New user - Me or Child";
      parameters = {
        OnboardingProgramType:
          data.choose_path === PAGE_PATH.myself
            ? "me"
            : (data.choose_path === PAGE_PATH.myself) === "parent"
            ? "child"
            : null,
      };
      break;
    case "parent_child_gender_select_page":
    case "gender_select_page":
      eventName = "New User - Gender";
      parameters = {
        Gender:
          data.choose_gender === "unknown"
            ? "prefer not to say"
            : data.choose_gender,
      };
      break;
    case "age_select_page":
      eventName = "New User - Age Range";
      parameters = {
        ageBracket: data.age_select,
      };
      break;
    case "parent_child_age_select_page":
      eventName = "New User - Age Range";
      parameters = {
        ageBracket:
          data.age_select === 21
            ? "5-9"
            : data.age_select === 22
            ? "10-13"
            : data.age_select === 24
            ? "14-17"
            : null,
      };
      break;
    case "treatment_select_page":
      eventName = "New User - Selected Treatments";
      parameters = {
        selectedTreatments: data.choose_treatments,
      };
      break;
    default:
      eventName = null;
      parameters = null;
      break;
  }

  return { eventName, parameters };
}

export function updateSegmentUser(currentPage, data) {
  let parameters = {};

  switch (currentPage) {
    case "anxiety_profile_feeling_page":
      parameters = {
        Feelings: data.choose_feeling,
      };
      break;
    case "anxiety_profile_comfortability_page":
      parameters = {
        Comforts: data.choose_comforts,
      };
      break;
    case "anxiety_profile_fears_page":
      parameters = {
        Fears: data.choose_fears,
      };
      break;
    case "name_input_page":
    case "parent_child_name_input_page":
      parameters = {
        name: data.name_input,
      };
      break;
    case "gender_select_page":
    case "parent_child_gender_select_page":
      parameters = {
        gender:
          data.choose_gender === "unknown"
            ? "prefer not to say"
            : data.choose_gender,
      };
      break;
    case "age_select_page":
      parameters = {
        age: data.age_select,
      };
      break;
    case "parent_child_age_select_page":
      parameters = {
        age:
          data.age_select === 21
            ? "5-9"
            : data.age_select === 22
            ? "10-13"
            : data.age_select === 24
            ? "14-17"
            : null,
      };
      break;
    default:
      parameters = null;
      break;
  }

  return parameters;
}

export function getCourseType(path) {
  switch (path) {
    case PAGE_PATH.myself:
      return "full";
    case PAGE_PATH.parent:
      return "child";
    default:
      return null;
  }
}
